<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("edit") }} {{ $tc("weekwiseContract", 2) }}
      </div>
      <router-link class="btn-blue" to="weekwise-contract"
        >{{ $tc("weekwiseContract", 2) }} {{ $tc("list", 2) }}
      </router-link>
    </div>
    <div class="white-wrapper">
      <div class="row mb-3">
        <div class="col-md-4 col-12">
          <label for="weekwise_name" class="form-label fw-bold small mb-1">
            {{ $t("weekwise") }} {{ $tc("contract", 2) }}
            {{ $tc("name", 2) }}
          </label>
          <input
            id="weekwise_name"
            v-model="contract_weekwise_name"
            v-b-tooltip.hover
            v-validate="'required'"
            :title="$t('contract_name_tooltip')"
            type="text"
            class="form-control slick-column"
            placeholder="Enter contract name"
          />
          <small class="text-danger">
            <span v-if="submitted && errors.has('weekwise_name')">
              {{ errors.first("weekwise_name") }}
            </span>
          </small>
        </div>
        <div class="col-lg-8 d-flex align-items-center justify-content-end">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="contracts_by_weekwise_is_active"
            />
          </div>
          <!-- <b-form-checkbox
            v-model="contracts_by_weekwise_is_active"
            name="check-button"
            switch
          >
            {{ $t("active") }}
          </b-form-checkbox> -->
        </div>
      </div>

      <!-- <div class="col-lg-12 mb-2">
            <h5 class="mb-0 heading">
              {{ $t("contract") }} {{ $tc("details", 2) }}
            </h5>
          </div> -->

      <table
        class="table table-bordered table-sm align-middle text-center no-padding-table"
      >
        <thead class="table-light">
          <tr>
            <th style="width: 30%">{{ $t("week") }}</th>
            <th style="width: 30%">{{ $t("contract") }}</th>
            <th style="width: 13%">Min Threshold</th>
            <th style="width: 13%">Complimentary %</th>
            <th style="width: 30%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(WeekwiseContract, WeekwiseContractKey) in WeekwiseContracts"
            :key="WeekwiseContractKey"
          >
            <!-- Week Select -->
            <td class="text-right p-0 slick-table-item">
              <multiselect
                id="select_week"
                :value="WeekwiseContract.contract_week"
                v-b-tooltip.hover
                v-validate
                :multiple="false"
                :options="
                  weekArray.filter(
                    (w) => w.value == WeekwiseContractKey || w.value == -1
                  )
                "
                :placeholder="selectedWeek"
                :title="$t('select_week_tooltip')"
                data-vv-name="Week"
                data-vv-rules="required"
                data-vv-value-path="value"
                label="name"
                name="select_week"
                track-by="value"
                @select="onSelectWeek($event, WeekwiseContractKey)"
              ></multiselect>
              <small
                class="text-danger"
                v-if="submitted && !WeekwiseContract.contract_week"
              >
                <span
                  v-if="submitted && WeekwiseContract.contract_week.length == 0"
                  >{{ selectedWeek }}</span
                >
              </small>
            </td>

            <!-- Contract Select -->
            <td class="text-right p-0 slick-table-item">
              <multiselect
                id="select_contract"
                :value="WeekwiseContract.contract_id"
                v-b-tooltip.hover
                :multiple="false"
                :options="ms_contracts"
                :placeholder="selectedContract"
                :title="$t('select_contract_tooltip')"
                label="contract_name"
                name="select_contract"
                track-by="contract_id"
                @select="onSelectContract($event, WeekwiseContractKey)"
              ></multiselect>
              <small
                class="text-danger"
                v-if="submitted && !WeekwiseContract.contract_id"
              >
                <span
                  v-if="submitted && WeekwiseContract.contract_id.length == 0"
                  >{{ selectedContract }}</span
                >
              </small>
            </td>

            <!-- Min Threshold -->
            <td class="text-right p-0 slick-column">
              <input
                v-model="WeekwiseContract.minimum_threshold"
                type="number"
                class="text-center"
                placeholder="0"
              />
            </td>

            <!-- Complimentary % -->
            <td class="text-right p-0 slick-column">
              <input
                v-model="WeekwiseContract.allowed_comp_percentage"
                type="number"
                class="text-center"
                placeholder="0"
              />
            </td>

            <!-- Action Buttons -->
            <td>
              <button
                v-if="WeekwiseContractKey === 0"
                class="btn-icon"
                @click.stop.prevent="addWeekWiseContract"
              >
                +
              </button>
              <button
                v-if="
                  WeekwiseContractKey !== 0 &&
                    WeekwiseContractKey === WeekwiseContracts.length - 1
                "
                class="btn-icon"
                @click.stop.prevent="
                  removeWeekWiseContract(WeekwiseContractKey)
                "
              >
                –
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="col-12 text-center pt-3">
        <button
          :disabled="btenable"
          class="btn-blue"
          @click.prevent.stop="onFinalSubmit"
        >
          Update Contract
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import MasterService from "@/services/MasterService";
  import DistributorService from "@/services/DistributorService";

  export default {
    data() {
      return {
        submitted: false,
        btenable: false,
        contract_weekwise_name: null,
        cbw_common_code: null,
        contracts_by_weekwise_is_active: true,
        ms_contracts: [],
        weekArray: [
          {
            name: "Week 1",
            value: 0,
          },
          {
            name: "Week 2",
            value: 1,
          },
          {
            name: "Week 3",
            value: 2,
          },
          {
            name: "Week 4",
            value: 3,
          },
          {
            name: "Week 5",
            value: 4,
          },
          {
            name: "Week 6",
            value: 5,
          },
          {
            name: "Thereafter",
            value: -1,
          },
        ],
        selectedContract: "Contract Type.",
        selectedWeek: "Week.",
        WeekwiseContracts: [
          // {
          //   contract_week: "",
          //   contract_id: ""
          // }
        ],
        removedWeekwiseContracts: [],
      };
    },
    mounted() {
      this.cbw_common_code = this.$route.query.cbw_common_code;
      if (this.cbw_common_code) {
        this.getActiveContracts();
      } else {
        this.$router.go(-1);
      }
    },
    methods: {
      getContractWeekwiseDetails: function() {
        let payload = {
          cbw_common_code: this.cbw_common_code,
        };
        DistributorService.GetSingleContractByWeekWiseDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.contract_weekwise_name =
                data.Records[0].contract_weekwise_name;
              data.Records.map((x) => {
                let weekArray = this.weekArray.filter((y) => {
                  return x.contract_week == y.value;
                });
                let contractArray = this.ms_contracts.filter((y) => {
                  return x.contract_id == y.contract_id;
                });
                this.WeekwiseContracts.push({
                  cbw_id: x.cbw_id,
                  contract_week: weekArray[0],
                  contract_id: contractArray[0],
                  minimum_threshold: x["minimum_threshold"],
                  allowed_comp_percentage: x["allowed_comp_percentage"],
                });
              });
              console.log("WeekwiseContracts=>", this.WeekwiseContracts);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getActiveContracts: function() {
        let payload = {
          tableName: "ms_contracts",
          contract_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ms_contracts = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(async () => {
            await this.getContractWeekwiseDetails();
          }); //message
      },
      addWeekWiseContract: function() {
        console.log("this.WeekwiseContracts", this.WeekwiseContracts);
        if (
          this.WeekwiseContracts.findIndex(
            (w) => w.contract_week.value == -1
          ) !== -1
        ) {
          this.$toasted.show(
            "You have already added Thereafter. Cannot add any more weeks"
          );
          return;
        } else {
          this.WeekwiseContracts.push({
            contract_week: "",
            contract_id: "",
            minimum_threshold: "",
            allowed_comp_percentage: "",
          });
        }
      },
      removeWeekWiseContract: function(index) {
        this.removedWeekwiseContracts.push(this.WeekwiseContracts[index]);
        this.WeekwiseContracts.splice(index, 1);
        console.log(
          "this.removedWeekwiseContracts :>> ",
          this.removedWeekwiseContracts
        );
      },
      onSelectWeek: function(event, index) {
        this.WeekwiseContracts[index].contract_week = event;

        if (event.value === -1 && this.WeekwiseContracts.length - 1 !== index) {
          this.WeekwiseContracts = this.WeekwiseContracts.slice(0, index + 1);
        }

        // let _index = this.weekArray.findIndex(x => {
        //   return x.value == event.value;
        // });
        // this.weekArray.splice(_index, 1);
      },
      onSelectContract: function(event, index) {
        this.WeekwiseContracts[index].contract_id = event;
      },
      ContractDetailsValidation: function() {
        let count = 0;
        this.WeekwiseContracts.map((x) => {
          if (x.contract_week.length == 0 || x.contract_id.length == 0) {
            count++;
          }
        });

        const thereAfterIndex = this.WeekwiseContracts.findIndex(
          (w) => w.contract_week.value == -1
        );

        if (thereAfterIndex === -1) {
          this.$toasted.show("Please add a 'ThereAfter' contract");
        }

        if (count > 0 || thereAfterIndex === -1) {
          return true;
        } else {
          return false;
        }
      },
      onFinalSubmit: function() {
        this.submitted = true;
        // let thereAfterArray = this.WeekwiseContracts.filter(x => {
        //   return x.contract_week.value == -1;
        // });
        this.$validator.validate().then((valid) => {
          if (valid) {
            if (this.ContractDetailsValidation()) {
              return;
            }
            // let updateArray=this.WeekwiseContracts.map((row)=>{
            //   row
            //   return {
            //     contract_id:row.contract_id,
            //     contract_week:row.contract_week,
            //     cbw_id:row.cbw_id?row.cbw_id:null
            //   }
            // })

            // let updateREmovedArray

            console.log("updateArray=>", this.WeekwiseContracts);
            this.btenable = true;
            let payload = {
              contract_weekwise_name: this.contract_weekwise_name,
              contracts_by_weekwise_is_active: this
                .contracts_by_weekwise_is_active
                ? "Y"
                : "N",
              WeekwiseContracts: this.WeekwiseContracts,
              removedWeekwiseContracts: this.removedWeekwiseContracts,
              cbw_common_code: this.cbw_common_code,
            };
            DistributorService.UpdateMasterContractByWeekWise(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.$validator.reset();
                  this.$router.push({
                    path: "weekwise-contract",
                  });
                  this.$toasted.show(data.message);
                } else {
                  if (data.error && data.error.sqlMessage) {
                    this.$toasted.show(data.error.sqlMessage);
                  } else {
                    this.$toasted.show(data.message);
                  }
                }
              })
              .catch(this._CatchError);
          }
        });
      },
    },
  };
</script>
<style>
  .back {
    background-color: #fff;
  }

  .slick-table-item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .slick-table-item .multiselect__placeholder {
    color: #00000085 !important;
    font-weight: 400 !important;
    font-style: italic;
  }

  .slick-column .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .slick-column input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .slick-column input::placeholder,
  .manual_bill_wrapper .multiselect__placeholder {
    font-size: 12px;
    font-style: italic;
  }
  /* Remove padding/margin from table cells */
  .no-padding-table th,
  .no-padding-table td {
    /* padding: 4px !important; */
    margin: 0 !important;
    vertical-align: middle !important;
  }

  .no-padding-table td {
    border: 1px solid #01070e;
  }

  .no-padding-table {
    zoom: 0.88;
  }

  /* Icon-only buttons (rounded border, no background) */
  .btn-icon {
    width: 28px;
    height: 28px;
    /* border: 1px solid #01070e; */
    border-radius: 50%;
    background: none;
    font-size: 16px;
    line-height: 1;
    padding: 0;
    text-align: center;
    cursor: pointer;
  }
  .btn-icon:hover {
    border-color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/WeekWiseContractComponents/editWeekwiseContract.vue